import { useEffect, useState } from "react";
import qs from 'querystring'
import { request_doctors, request_hospitals, request_patients_v2 } from "./requests";
import { PATIENT_STATUS, USER_TYPE } from "../../../../variables/config";
import { catalogs } from "../../../../variables/catalogs";
import { usePlatformContext } from "../../../../context/PlatformContext";

const usePatients = ({history, user_level, parentuser}) => {

    const platformContext = usePlatformContext()
    const {programId} = platformContext.state
    const [loading, setLoading] = useState(false)
    const [patients, setPatients] = useState([])
    const [hospitals, setHospitals] = useState([])
    const [doctors, setDoctors] = useState([])
    const [filter, setFilter] = useState({general:null})
    const [total, setTotal] = useState(0)
    const [expandable, setExpandable] = useState(false)
    const [table_config, setTableConfig] = useState({
        filter:{
            general:null,
            status:null,
            doctor:null,
            hospital:null,
            patient_type:null,
            product_type:null
        },
        searchText:'',
        page:0,
        rowsPerPage:5,
    })
    const [view, setView] = useState(1)
    const [modals, setModals] = useState({
        warning_delete_user:{open:false, issending:false, error:null, id:null}
    })
    const [success, setSuccess] = useState({
        open:false,timeout:2000,type:'success',message:'¡Acción exitosa!'
    })

    useEffect(() => {
        const initModule = async() => {
          actions.onInitModule()
        }
        const data = JSON.parse(localStorage.getItem('data')) 
        if(data) initModule()
      },[])
    
      useEffect(() => {
        console.log('Volver a pedir')
        const data = JSON.parse(localStorage.getItem('data')) 
        if(data) actions.onSearchAplicants()
        
      }, [table_config, parentuser, user_level, programId])

    const actions = {
        onPatientSelected: (id) => {
            let temp = { page:table_config.page, rowsPerPage:table_config.rowsPerPage}
            localStorage.setItem('patients_config', JSON.stringify(temp))
            history.push(`/patients/${id}`)
        },
        onAddPatient: () => {
            history.push('/patients/add')
        },
        onPreDeleteUser: () => {

        },
        onChangeTableConfig: async(data) => {
            console.log(data)
            let temp = {...data}
            temp.isSearch = data.filter && data.filter.general && data.filter.general.id !== null && data.filter.general.id !== undefined
            setTableConfig(temp)
        },
        onChangeFilter: (data) => {
            console.log(data)
        },
        onInitModule: async() => {
            try {
                setLoading(true)
                let _table_config = {...table_config}
                // Check if there was something in local storage to save a previous config on filters
                const prev_config = localStorage.getItem('patients_config')
                const _doctors = await request_doctors()
                const _hospitals = await request_hospitals()
                setDoctors(_doctors)
                setHospitals(_hospitals)
                if(prev_config){
                    _table_config = {..._table_config, ...JSON.parse(prev_config)}
                    setTableConfig(_table_config)
                }                
            } catch (error) {
                
            }
            setLoading(false)
        },
        onChangeView:(value) =>{
            let _table_config = {...table_config}
            if(value === 2){
                _table_config.filter.status = catalogs.spanish.patient_statuses[1]
            }else{
                _table_config.filter.status = null
            }
            setTableConfig(_table_config)
            setView(value)
        },
        onSearchAplicants: async() => {
            try {
                const params = onGetParamsQuery()  
                console.log('Search Applicants', params)
                const patients_request = await request_patients_v2(params)
                setTotal(patients_request.count)
                setPatients(patients_request.patients)
            } catch (error) {
                console.log(error)
            }
        },
        onUpdateExpandableView: (value) => {
            setExpandable(value)
        },
        onEditModal: (section,data) => {
            let _modals = {...modals}
            _modals[section] = {..._modals[section], ...data}
            setModals(_modals)
        },
        onCloseModal: (type) => {
            actions.onEditModal(type, {open:false, issending:false, error:null})
        },
        onCloseSnackbar: () => {
            let temp = {...success}
            temp.open = false
            setSuccess(temp)
        },
        onActivateSuccessSnack: () => {
            let temp = {...success}
            temp.open = true
            setSuccess(temp)
        }
    }

    const onGetParamsQuery = () => {
        console.log('User level', user_level)
        const {filter, searchText, page, rowsPerPage} = table_config
        let args = {limit:rowsPerPage, offset:page*rowsPerPage, order:1, order_by:'external_id'}
        let filterArgs = []
        //filterArgs.push({"field":"product_type_id","operator":"=","value":1})
        if(filter && filter.general ){
            console.log(filter.general)
            if(searchText) filterArgs.push({"field":filter.general.key,"operator":"LIKE","value":`%${searchText}%`})
        }
        //if(searchText) filterArgs.push({"field":"name","operator":"LIKE","value":`%${searchText}%`})
        if(filter && filter.status && filter.status.id) filterArgs.push({"field":"status_id","operator":"=","value":`${filter.status.id}`})
        if(filter && filter.patient_type && filter.patient_type.id) filterArgs.push({"field":"patient_type_id","operator":"=","value":`${filter.patient_type.id}`})
        if(filter && filter.doctor && filter.doctor.id) filterArgs.push({"field":"doctor_id","operator":"=","value":`${filter.doctor.id}`})
        if(filter && filter.hospital && filter.hospital.id) filterArgs.push({"field":"main_hospital_id","operator":"=","value":`${filter.hospital.id}`})
        
        if(user_level){
            switch(user_level){
                case USER_TYPE.ADMIN:
                case USER_TYPE.ROCHE:
                    if(programId && programId > 0) filterArgs.push({"field":"product_type_id","operator":"=","value":`${programId}`})
                    break;
                case USER_TYPE.HOSPITAL:
                    filterArgs.push({"field":"product_type_id","operator":"=","value":1})
                    break;
                case USER_TYPE.MERCURIO:
                    if(parentuser && parentuser.agency_id) filterArgs.push({"field":"product_type_id","operator":"=","value":parentuser.agency_id === 1 ? 1 : 2})
                    break;
            }
        }
        let response = `?${qs.stringify(args)}`
        if(filterArgs.length) response = `${response}&filter=${encodeURIComponent(JSON.stringify(filterArgs))}`
        return response
    }


    return {
        loading, setLoading,
        patients, setPatients,
        hospitals, setHospitals,
        doctors, setDoctors,
        filter, setFilter,
        total, setTotal,
        table_config, setTableConfig,
        modals, setModals,
        success, setSuccess,
        expandable,
        view, setView,
        actions
    }

}

export default usePatients;